// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class VehicleResource extends Resource {
    basePath: string = 'services/providers/vehicles/';

    objectPath: string = 'services/providers/vehicles/{ident}/';
}
